import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    setMobileOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const linkClass = 'text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-gray-700 hover:text-accent';

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20 gap-4">
            {/* Logo */}
            <button
              onClick={() => scrollToSection('home')}
              className="flex items-center cursor-pointer flex-shrink-0 min-w-[80px]"
            >
              <img
                src="https://static.readdy.ai/image/aed34eea4e280644dc241a74366b8cb3/65189eab8d9d4e700ee7712d44e24f60.png"
                alt="OA Logo"
                className="h-12 w-auto object-contain flex-shrink-0 brightness-0"
              />
            </button>

            {/* Desktop nav */}
            <div className="hidden md:flex items-center space-x-5 flex-shrink min-w-0">
              <Link to="/about" className={linkClass} onClick={() => { setMobileOpen(false); window.scrollTo({ top: 0, behavior: 'instant' }); }}>About Me</Link>
              <button onClick={() => scrollToSection('research')} className={linkClass}>Curatorial Projects &amp; Exhibitions</button>
              <Link to="/research-film-projects" className={linkClass} onClick={() => { setMobileOpen(false); window.scrollTo({ top: 0, behavior: 'instant' }); }}>Research Film Projects</Link>
              <Link to="/publications" className={linkClass} onClick={() => { setMobileOpen(false); window.scrollTo({ top: 0, behavior: 'instant' }); }}>Books &amp; Publications</Link>
              <button onClick={() => scrollToSection('affiliations')} className={linkClass}>International Affiliations</button>
              <button onClick={() => scrollToSection('press')} className={linkClass}>Media Press Mentions</button>
              <button onClick={() => scrollToSection('contact')} className={linkClass}>Contact Me</button>
            </div>

            {/* Mobile hamburger */}
            <button
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-gray-700"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-20 px-6 flex flex-col gap-6 md:hidden">
          <Link to="/about" onClick={() => { setMobileOpen(false); window.scrollTo({ top: 0, behavior: 'instant' }); }} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2 border-b border-stone-100">About Me</Link>
          <button onClick={() => scrollToSection('research')} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2 border-b border-stone-100">Curatorial Projects &amp; Exhibitions</button>
          <Link to="/research-film-projects" onClick={() => { setMobileOpen(false); window.scrollTo({ top: 0, behavior: 'instant' }); }} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2 border-b border-stone-100">Research Film Projects</Link>
          <Link to="/publications" onClick={() => { setMobileOpen(false); window.scrollTo({ top: 0, behavior: 'instant' }); }} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2 border-b border-stone-100">Books &amp; Publications</Link>
          <button onClick={() => scrollToSection('affiliations')} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2 border-b border-stone-100">International Affiliations</button>
          <button onClick={() => scrollToSection('press')} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2 border-b border-stone-100">Media Press Mentions</button>
          <button onClick={() => scrollToSection('contact')} className="text-left text-lg font-medium text-gray-800 cursor-pointer py-2">Contact Me</button>
        </div>
      )}
    </>
  );
}
